<template>
    <div>
         <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
             <v-col xs="12" sm="12" lg="12" md="12" cols="12">
                 <center class="heading"><strong>Student Result Status</strong></center>
                 <!-- {{all_learner_data}} -->
             </v-col>
        <v-data-table :headers="headers1" :items="all_learner_data" sort-by class="elevation-1 mytable" :search="search" >
           <template v-slot:top>
                <v-toolbar flat dense color="white">
                    <download-excel :data="all_learner_data" worksheet="all_learner_data" :fields="data_list" name="Student_Result_Status_Report.xls">
                        <v-btn color="success" class="ma-2 white--text downbtn">
                            <v-icon left dark>mdi-file-excel</v-icon>
                            export xls
                        </v-btn>
                    </download-excel>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                </v-text-field>
                </v-toolbar>
           </template> 
           <template v-slot:item.actions="{ item }">
          <v-switch v-model="item.isactive"  @change="editItem(item)"></v-switch>
        </template>          
        </v-data-table>
         </v-card>
    </div>
</template>
<script>
 import "@/assets/css/color.css";
  import axios from "axios";
export default {
    data() {
            return {
                loader: false,
                snackbar_msg: "",
                snackbar: false,
                color: "",
                search:"",
                all_learner_data:[],
                data_list: {
                    "Sr. No.": "srno",
                    "Seat No" : "seat_number",
                    "Rgistration No" : "registration_number",
                    "Name": "name",
                    "Program":"program",
                    "Status": "block",
                },
                 headers1: [
                    { text: "Sr No", value: "srno" },
                    { text: "Rgistration No.", value: "registration_number" },
                    { text: "Seat Number",value: "seat_number"},
                    { text: "Name", value: "name" },
                    { text: "Program", value:"program"},
                    { text: "Activate/Deactivate", value: "actions", sortable: false }
                ],
            };
        },
        mounted() {
            this.onLoad();
        },
         methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
             editItem(item)
            {
               //alert(item.id)
                const data={
                    id:item.id
                }
                 axios
                .post("/StudentAttendanceReport/blocklearnerResult",data)  
                .then(res => {
                    if (res.data.flag == "YES") {
                         this.showSnackbar("success","Student Result Status Updated Successfully...")
                         //this.showSnackbar("success", "Load!!!");
                    }
                })
                .catch(error => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {
                });
            },
             onLoad() {
                axios
                    .post("/StudentAttendanceReport/getLearner")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.all_learner_data = res.data.all_learner_data;
                            //  this.showSnackbar("success", "Load!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                    });
            },
            
         },
        

    
}
</script>
<style  scoped>
.box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
    .date >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
      .mytable /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        white-space: nowrap !important;
    }
</style>